module.exports = __webpack_public_path__ + "static/media/Karine Lima.b58eab99.jpg";